import { trigger, transition, state, style, animate} from '@angular/animations';

export const FLIP_CLOCK_ANIMATIONS = [
    trigger('fade', [
        state('fade-in', style({
            opacity: 1
        })),
        state('fade-out', style({
            opacity: 0
        })),
        transition('* => fade-out', animate('1000ms')),
        transition('* => fade-in', animate('1000ms')),
        transition('fade-in => fade-out', animate('1000ms')),
        transition('fade-out => fade-in', animate('1000ms'))
    ])
];
